module.exports = __webpack_public_path__ + "static/media/รายงานผลลูกหนี้ค้างชำระ_ตามประเภทลูกหนี้.d5ba0609.xls";